import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


const {t, locale} = useI18n({useScope: 'global'})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(locale) ? (locale).value = $event : null))
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("option", { value: "en-US" }, "English", -1),
          _createElementVNode("option", { value: "fr-FR" }, "French", -1),
          _createElementVNode("option", { value: "ar-AE" }, "Arabic", -1)
        ]), 512), [
          [_vModelSelect, _unref(locale)]
        ])
      ])
    ]),
    _createElementVNode("h1", null, _toDisplayString(_unref(t)('greet')), 1)
  ]))
}
}

})